import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { fetchReferralLeaderboard } from "../../actions/referralActions";
import { downloadBtnStyle, downloadCSV } from "./shared";

const CustomerLeaderboard = ({ fromDate, toDate }) => {
  const dispatch = useDispatch();
  const [leaderboardPage, setLeaderboardPage] = useState(1);

  const { loading: leaderboardLoading, data: leaderboardData, error: leaderboardError } =
    useSelector((state) => state.getReferralLeaderboard) || {};

  const leaderboard = leaderboardData?.data?.referrals;

  const handleLeaderboardPageChange = (page) => {
    setLeaderboardPage(page);
    dispatch(fetchReferralLeaderboard(page, 100, fromDate, toDate));
  };

  const handleDownloadLeaderboard = () => {
    if (!leaderboard?.items?.length) {
      toast.warning("No leaderboard data to download");
      return;
    }
    downloadCSV(
      "leaderboard",
      ["Position", "Referrer Tag", "Referrer Name", "Referral Count", "Referral Points"],
      leaderboard.items.map((i) => [i.position, i.referrer_tag, i.referrer_name || "", i.referral_count, i.referral_points]),
    );
  };

  if (leaderboardLoading) return <Loader />;
  if (leaderboardError) return <p className="text-danger text-center">{leaderboardError}</p>;

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
        <button onClick={handleDownloadLeaderboard} style={downloadBtnStyle}>⬇ Download CSV</button>
      </div>
      <MDBTable responsive style={{ width: "100%", fontSize: "14px" }}>
        <MDBTableHead>
          <tr>
            <th>Position</th>
            <th>Referrer Tag</th>
            <th>Referrer Name</th>
            <th>Referral Count</th>
            <th>Referral Points</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {leaderboard?.items?.length > 0 ? (
            leaderboard.items.map((item) => (
              <tr key={item.referrer_id}>
                <td>
                  <span style={{ fontWeight: "700", color: item.position === 1 ? "#FFD700" : item.position === 2 ? "#C0C0C0" : item.position === 3 ? "#CD7F32" : "#fff" }}>
                    #{item.position}
                  </span>
                </td>
                <td>{item.referrer_tag}</td>
                <td>{item.referrer_name || "-"}</td>
                <td>{item.referral_count}</td>
                <td>{item.referral_points}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>No leaderboard data found</td>
            </tr>
          )}
        </MDBTableBody>
      </MDBTable>

      {leaderboard?.page?.total_page > 1 && (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "16px" }}>
          {Array.from({ length: leaderboard.page.total_page }, (_, i) => i + 1).map((page) => (
            <button key={page} onClick={() => handleLeaderboardPageChange(page)} style={{ padding: "6px 12px", border: "1px solid #444", borderRadius: "4px", background: leaderboardPage === page ? "#007bff" : "#1a1a1a", color: "#fff", cursor: "pointer" }}>
              {page}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default CustomerLeaderboard;
